export function createDict(arr) {
  return arr.reduce(function (acc, curr) {
    acc[curr[0]] = curr[1];
    return acc;
  }, {});
}
export var rgbaWithOpacity = function rgbaWithOpacity(rgba, opacity) {
  return rgba.replace('1)', "".concat(opacity, ")"));
};